<template>
    <!-- 详情浮层 -->
    <div class="showPopBox el-popover">
        <div style="font-szie: 13px; margin-bottom: 10px; text-align: center">
            {{ showData.department_label }}&nbsp;({{ showData.label }})
        </div>

        <div>
            <div
                class="item"
                v-for="(item, index) in showData.persons_enable"
                :key="index"
                style="width: 300px; display: flex; flex-direction: column; align-items: center"
            >
                <el-image
                    class="face"
                    :src="item.picture || 'http://img.chenpon.com/default.svg'"
                    :preview-src-list="[item.picture || 'http://img.chenpon.com/default.svg']"
                >
                    <div slot="error" class="image-slot">
                        <img src="http://img.chenpon.com/default.svg" class="headImg" />
                    </div>
                </el-image>
                <div class="name popItem">
                    {{ item.name }}
                </div>
                <div class="popItem">
                    <label for="">年龄：</label>
                    {{ item.age }}
                </div>
                <div class="popItem">
                    <label for="">司龄：</label>
                    {{ item.in_working_years }}
                </div>
                <div class="tel popItem">
                    <label for="">学历：</label>
                    {{ item.educational }}
                </div>
                <div class="tel popItem">
                    <label for="">备注：</label>
                    {{ item.remark }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['showData'],
    data() {
        return {
            defaultexpandedkeys: []
        };
    },
    mounted() {},

    created() {},
    methods: {}
};
</script>
<style>
.showPopBox {
    position: absolute;
    top: 0px;
    left: 226px;
    visibility: hidden;
    z-index: 1000000;
}
.clickBtn {
    position: absolute;
    right: 9px;
    font-weight: bold;
    z-index: 1000;
    color: gray;
    display: none;
}
.relative {
    position: relative;
}
.relative:hover .clickBtn {
    display: block;
}
.org-chart-node-label-inner {
    padding: 0 !important;
    position: relative;
}

.cardHeader {
    width: 100%;
    height: 30px;
    background-color: aqua;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.cardMain {
    padding-left: 10px;
    font-size: 15px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis !important;
    position: relative;
}

.style0 {
    background: rgb(41, 101, 56);
}

.style1 {
    background: rgb(255, 0, 0);
}

.style2 {
    background: orange;
}

.style3 {
    background: rgb(196, 205, 31);
}

.style4 {
    background: rgb(0, 183, 255);
}

.style5 {
    background: rgb(0, 76, 255);
}

.style6 {
    background: rgb(128, 0, 92);
}

.style7 {
    background: fuchsia;
}

.el-popover .item {
    position: relative;
    width: 100%;
    padding-bottom: 15px;
}

.el-popover .item .face {
    display: block;
    width: 45px;
    height: 60px;
    margin: 4px 0;
}

.el-popover .item .name {
    width: 180px;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
}

.el-popover .item .tel {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
}

.el-popover .item .tel i {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    margin-right: 6px;
    border-radius: 1px;
}

.department_role {
    height: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    padding-left: 10px;
    font-size: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis !important;
}
.popItem {
    width: 70%;
    margin-top: 10px;
}
.popItem label {
    width: 30%;
    display: inline-block;
}
.department_role_line {
    height: 1px;
}

.headImg {
    max-height: 60px;
    max-width: 45px;
    margin-left: 0px;
    margin-top: -5px;
}

.cardMantime {
    border-radius: 5px;
    color: gray;
    font-size: 8px;
}

.cardInfo {
    margin-top: 10px;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
}

.vertical .org-chart-node:after,
.vertical .org-chart-node:before:nth-last-child(1) {
    display: none;
}

.vertical .org-chart-node-children {
    display: flex;
}
.mobileSty {
    margin-top: 5px;
    font-size: 11px;
}
.none {
    visibility: hidden !important;
}
</style>
